import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import Textarea from 'components/shared/debouncedTextArea';
import * as actions from 'actions/pathBuilder';

const PathName = ({ title, updateTitle, isCertification, features }) => (
  <div className="mb-16">
    <label className="mb-8 c-brand-gray-darker" htmlFor="pathName">
      {isCertification &&
        t(
          'certifications.certification_builder.name_input_label_certification',
        )}
      {!isCertification && t('paths.path_builder.header.name_input_label')}
    </label>
    <Textarea
      id="pathName"
      className="PathBuilder-nameInput NewInput--white"
      onChange={updateTitle}
      value={title}
      controlled
      wait={0}
    />
  </div>
);

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  title: pathBuilder.title,
  isCertification: !!get('certification')(pathBuilder),
});

const mapDispatchToProps = dispatch => ({
  updateTitle(title) {
    dispatch(actions.updatePath({ title }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PathName);
